import { DatePicker, Form, message, Modal, Typography } from 'antd'
import type { Dayjs } from 'dayjs'
import { useState } from 'react'

import { MonoId } from '@/components/common/MonoId'

import type { PriceResourceType } from './priceUtils'
import { postPriceUpdate } from './priceUtils'

interface Props {
  open: boolean
  onClose: () => void
  onSuccess: () => void
  resourceType: PriceResourceType
  priceId: string
}

export function EditPriceModal({
  open,
  onClose,
  onSuccess,
  resourceType,
  priceId,
}: Props) {
  const [form] = Form.useForm<{ activeUntil: Dayjs }>()
  const [saving, setSaving] = useState(false)

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setSaving(true)

      await postPriceUpdate(resourceType, {
        update: {
          [priceId]: {
            activeUntil: values.activeUntil.toISOString(),
          },
        },
      })

      void message.success('Price updated')
      form.resetFields()
      onSuccess()
    } catch (error) {
      if (error instanceof Error) {
        void message.error(error.message)
      }
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      title={`Set Active Until · ${resourceType} price`}
      open={open}
      onCancel={onClose}
      onOk={() => void handleSubmit()}
      okText="Set Active Until"
      confirmLoading={saving}
      destroyOnClose
    >
      <Typography.Paragraph type="secondary">
        Price <MonoId id={priceId} />
      </Typography.Paragraph>
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="activeUntil"
          label="Active Until"
          rules={[{ required: true }]}
        >
          <DatePicker showTime style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
